import styles from '../assets/styles/components/Button.module.scss';
import ReactLoading from 'react-loading';
import classNames from 'classnames';
interface IProps {
  isValid: boolean;
  loading: boolean;
  onClick?: () => void;
  text: string;
  color?: string;
  bgColor?: string;
  disabledBgColor?: string;
}
export const Button = ({ isValid, loading, text, color, bgColor, onClick, disabledBgColor }: IProps) => {
  return (
    <button
      type='submit'
      className={classNames(styles.btn, isValid ? styles.valid : styles.disabled)}
      data-testid='sendPassword'
      style={{ color, backgroundColor: disabledBgColor ? (isValid ? bgColor : disabledBgColor) : bgColor }}
      onClick={onClick}
    >
      <div className={styles.container}>
        {text}
        {loading && (
          <div className={styles.loader}>
            <div style={{ flex: 0 }}>
              <ReactLoading type='spin' width={'1.5rem'} height={'1.5rem'} />
            </div>
          </div>
        )}
      </div>
    </button>
  );
};
